import { render, staticRenderFns } from "./TenantBrandingTab.vue?vue&type=template&id=49cbbeaa"
import script from "./TenantBrandingTab.vue?vue&type=script&lang=ts"
export * from "./TenantBrandingTab.vue?vue&type=script&lang=ts"
import style0 from "./TenantBrandingTab.vue?vue&type=style&index=0&id=49cbbeaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports